export default {
  "short lang": "kz",
  lang: "Тіл",
  "my finances": "Қаражатым",
  errands: "Тапсырмалар",
  instruments: "Құралдар",
  reports: "Есептер",
  total: "Барлығы",
  Mln: " Млн",
  Bil: " Млрд",
  "amount in ": "Соммасы ",
  incomeSinceYearBeginning: "Жыл басынан бергі рентабельділік",
  "broker account": "Брокерлік шот",
  "current balance": "Ағымдағы активтер",
  profitability: "Табыстылық",
  "profitability title": "Табыстылық",
  "blocked amount": "Бұғатталған қаражат",
  "available funds": "Бос қаражат",
  invest: "Инвестициялау",
  "deferred companies": "Кейінге қалдырылған компаниялар",
  replenish: "Толтыру",
  overview: "Шолу",
  portfolio: "Портфель",
  transactions: "Мәмілелер",
  analysis: "Талдау",
  "during the period": "Кезең",
  "for today": "Бүгінге",
  week: "Апта",
  month: "Ай",
  "half year": "Жарты жыл",
  year: "Жыл",
  quarter: "Тоқсан",
  "portfolio structure": "Портфель құрылымы",
  tenge: "Тенге",
  dollars: "Доллар",
  "by country": "Ел бойынша",
  "by financial instruments": "Қаржы құралдары бойынша",
  "by sector": "Салалар бойынша",
  back: "< Артқа",
  cash: "Ақшалай қаражат",
  securities: "Құнды қағаз",
  debts: "Қарыздар",
  sale: "Сату",
  purchase: "Сатып алу",
  "order book": "Тапсырыс журналы",
  direct: "Тікелей",
  opposite: "Кері",
  "date of application": "Берілген күні",
  description: "Сипаттамасы",
  quantity: "Саны",
  nominal: "Номинал",
  nominal_value: "Номинал",
  price: "Бағасы",
  sum: "Суммасы",
  status: "Күйі",

  "set of tools": "Құралдар жинағы",
  tool: "Аспап",
  currency: "Валюта",
  "market price": "Купонды қосқандағы нарықтық баға",
  favorites: "Таңдаулылар",
  buy: "Сатып алу",

  "account reports": "Шот бойынша есептер",
  "facial count statement": "Шот бойынша үзінді көшірме",
  "report on transactions and operations":
    "Аяқталған операциялар мен операциялар туралы есеп",
  "securities and cash flow statement":
    "Бағалы қағаздар және ақша қаражаттарының қозғалысы туралы есеп",
  "securities income payment notice":
    "Бағалы қағаздар бойынша кірістерді төлеу туралы хабарлама",
  download: "Жүктеу",

  "my assets": "Менің активтерім",
  title: "Аты",
  "purchase value": "Сатып алу құны",
  lesion: "Шығын",
  "market cost": "Нарықтық құны",

  "select date range": "Кезеңді таңдаңыз",
  "select date": "Датаны таңдаңыз",
  "select portfolio": "Портфельді таңдаңыз",
  entrance: "Кіру",
  "user name": "Логин",
  password: "Құпия сөз",
  login: "Кіру",
  "password recovery": "Құпия сөзді қалпына келтіру",

  "unsubscribe text": "Сіз ақпараттық бюллетеннен бас тарттыңыз",
  "national bank rate": "Қазақстан ҰБ бағамы",

  "personal account": "Жеке Бөлме",
  contacts: "Байланыс",
  "contact us": "Бізге хабарласыңыз",
  "back call": "Кері қоңырау шалыңыз",
  "call back within 15 minutes": "Сізге 15 минут ішінде қайта қоңырау шаламыз",
  "call me back": "Маған қоңырау шалыңыз",
  "buy security": "ҚҚ сатып алыңыз",
  "add instrument": "Құралды қосу",

  eds: "ЭЦҚ",
  "eds login": "ЭЦҚ Кіру",
  cancel: "Болдырмау",
  "first name and last name": "Аты-жөні",
  "serial number": "Сериялық нөмір",
  search: "Табу",
  "Account Statement": "Жеке шоттан үзінді көшірме",
  "Payments Of Incomes": "БҚ бойынша табыстың төлемақысы туралы құлақтандыру",
  "Movement of securities and cash": "БҚ және АҚ қозғалысы туралы есеп",
  "Completed transactions and operations":
    "Жасалған мәмілелер мен операциялар туралы есеп",

  "download the app": "Бағдарламаны жүктеп алыңыз",
  "for more efficient work, we recommend that you download our mobile application":
    "Тиімді жұмыс істеу үшін мобильді қосымшаны жүктеп алуды ұсынамыз",

  "asset dynamics": "Активтер динамикасы",
  confirm: "Растаңыз",
  resend: "Қайта жіберу",
  resend_text: "Сіз кодты қайта жібере аласыз",
  "recovery code is incorrect": "Қалпына келтіру коды дұрыс емес",
  "incorrect user name": "Пайдаланушы аты жарамсыз",
  "repeat password": "Құпия сөзді қайталаңыз",
  "enter new password": "Жаңа парольді енгізіңіз",
  "change password": "Құпия сөзді өзгерту",
  "passwords must match": "Парольдер сәйкес келуі керек",
  "home page": "Басты бет",
  "password changes successfully": "Пароль сәтті өзгертілді",
  "password changes error":
    "Құпия сөзді қалпына келтіру кезінде қате пайда болды",
  others: "Басқалары",
  "sec type": "ҚҚ типі",
  "deal type": "Мәміле типі",
  "deal date": "Мәміле датасы",
  rating: "Рейтингтер",
  "coupon rate": "Купон бағасы",
  "maturity date": "Өтеу уақыты",
  "income coupon": "Жинақталған купон",
  dividends: "Дивиденттер",
  "buy securities": "Бағалы қағаздарды сатып алыңыз",
  "sell securities": "Бағалы қағаздарды сату",
  issuer: "Эмитент",
  "security name": "Аты",
  ask: "Аск",
  bid: "Бид",
  amount: "Саны",
  "date of expiration": "Жарамдылық мерзімі",
  sell: "Cату",
  validity: "Жарамдылық мерзімі",
  "publisher name": "Шығарушының аты",
  algorithm: "Алгоритм",
  "passwords do not match": "Парольдер сәйкес келмейді",
  "new password": "Жаңа пароль",
  "old password": "Ескі пароль",
  "repeat new password": "Жаңа парольді қайталаңыз",
  "password change": "Парольді өзгерту",
  save: "Yнемдеңіз",
  "required field": "Келесілерді толтырыңыз:",
  pifs: "ПИФтер",
  "holder name": "банк/брокерлік компания атауы",
  "acc type": "Счет типі",
  "bank account": "Счет номері",
  summ: "Суммасы",
  "payment purpose": "Қарыз типі",
  "trade code": "Сауда коды",
  "debit type": "Қарыз түрі",
  number: "Нөмір",
  comments: "Түсінік",
  annual: "Жылдық",
  accumulated: "Жинақталған",
  category_sec: "Категория",
  "interest charges": "Есептелген сыйақы",

  //--------------------LKSTASKS-i18n start

  iin: "",
  "incorrect iin": "",
  "last name": "",
  "first name": "",
  patronymic: "",
  "mobile number": "",
  "email address": "",
  "incorrect form format": "",

  "register page": "",
  "individual account": "",
  "corporate account": "",

  "full name": "",
  bin: "",
  "incorrect bin": "",
  loading: "",
  error: "",
  "data sent": "",

  "register info": "",
  "short name": "",
  "legal form": "",
  "register document type": "",
  "document number": "",
  "document issuing date": "",
  "register location": "",
  "internet resource name": "",
  "choose new file": "",
  "choose file": "",
  "choose country": "",
  "website link": "",
  "id document number": "",
  "error save": "",
  "new governing body": "",

  "license info": "",
  "buss activity type": "",
  "license number": "",
  "license issue date": "",
  "license validity period": "",
  "name of the issuing authority": "",

  "register address": "",
  country: "",
  city: "",
  street: "",
  address: "",
  house: "",
  block: "",
  apartment: "",
  "post index": "",
  "address of actual": "",
  location: "",
  residence: "",
  "coincides with register address": "",
  "actual address": "",
  "register actual address": "",

  "taxpayer info": "",
  "taxpayer country": "",
  "bank details": "",
  lei: "",
  giin: "",
  "register number": "",
  "register number placeholder": "",
  "taxpayer number": "",

  "owner info": "",
  delete: "",
  "organization form": "",
  share: "",
  from: "",
  to: "",
  add: "",
  info: "",
  next: "",
  "data saved": "",
  "location address": "",
  "fill form": "",
  "cannot be lower '0%' or higher": "",

  "management structure": "",
  "managing organ name": "",
  create: "",
  continue: "",
  deleted: "",
  "delete error": "",
  "attach file": "",
  "attach files": "",

  "client representative info": "",
  "client third party info": "",
  "empty list": "",

  "branch/representative additional info": "",
  change: "",
  "branch name": "",
  "bin (if available)": "",
  "document type register confirm": "",
  "body register name": "",
  "register date (re-register)": "",
  "registered address of the branch (representative office)": "",

  "financing sources info": "",
  "income sources list": "",
  "bank account list": "",
  "choose bank": "",
  "bank name": "",
  "account number": "",
  "total annual income": "",
  "characteristics of financial condition": "",
  "your income source": "",
  "financial condition total cost": "",
  "liabilities total value": "",
  "countries main operating assets": "",
  "changes saved": "",
  "empty field": "",
  adding: "",
  "fill fields": "",
  "not chosen": "",
  "repeatedly through": "",
  "(le real estate, values, capital share)": "",
  other: "",

  "services provision procedure": "",
  contract: "",
  link: "",
  tariffs: "",
  "user manual": "",
  "send sms code": "",
  "verification code": "",
  "check code": "",
  "sms confirm sent": "",
  "input code": "",
  "confirmation code accepted": "",
  "confirmation code not accepted": "",
  wait: "",
  "confirmation code sent to number": "",
  "confirmation code not sent": "",
  "accept contract condition": "",
  "number changed": "",
  "number not saved": "",
  "register end": "",
  "go back correct": "",
  "complete registration": "",
  "application accepted": "",
  "check data/ prepare docs": "",
  "application status track": "",
  "questions by phone": "",
  "contact phone / email": "",
  "registration completed": "",
  "already uploaded": "",
  "maximum size 5mb": "",

  identification: "",
  citizenship: "",
  birthday: "",
  "birth place": "",
  "document type": "",
  series: "",
  "issue date": "",
  expires: "",
  "issued by": "",
  "visa migration card": "",
  "visa number": "",
  "document expires": "",
  "migration card number": "",

  "job info": "",
  "tax residency": "",
  "work place position": "",
  "entrepreneurial/license activity": "",
  "document photo front": "",
  "document photo back": "",
  "passport driving license internal passport": "",
  "send files": "",
  "document uploaded": "",
  "file upload error": "",
  // --------------------------------------documents
  "charter le / Regulation branch or representative office": "",
  "state register certificate": "",
  "le activity license": "",
  "holders register extract": "",
  "signatures notarized document": "",
  "non-residents register certificate": "",
  "executive body id": "",
  "beneficial le id": "",
  "consolidated financial statements": "",
  "FATCA tax form (original)": "",
  "agreement terms confirm": "",
  "le body proxy / decision": "",
  "le representative / head/ office id": "",
  "Another session started": "Выполнен вход с другого устройства",
  "Active token not found": "Время вашей сессии истекло"
};
